/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstTransportRelationUpdateBase
 */
export interface MstTransportRelationUpdateBase {
    /**
     * 
     * @type {boolean}
     * @memberof MstTransportRelationUpdateBase
     */
    deleteFlg?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstTransportRelationUpdateBase
     */
    insertDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelationUpdateBase
     */
    insertUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstTransportRelationUpdateBase
     */
    updateDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelationUpdateBase
     */
    updateUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstTransportRelationUpdateBase
     */
    deleteDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelationUpdateBase
     */
    deleteUser?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstTransportRelationUpdateBase
     */
    companyId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelationUpdateBase
     */
    orgCenterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelationUpdateBase
     */
    orgCustomerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelationUpdateBase
     */
    orgCustomerCenterId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstTransportRelationUpdateBase
     */
    leadtime?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstTransportRelationUpdateBase
     */
    maxTrafficVolume?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstTransportRelationUpdateBase
     */
    remarks?: string | null;
}

/**
 * Check if a given object implements the MstTransportRelationUpdateBase interface.
 */
export function instanceOfMstTransportRelationUpdateBase(value: object): value is MstTransportRelationUpdateBase {
    return true;
}

export function MstTransportRelationUpdateBaseFromJSON(json: any): MstTransportRelationUpdateBase {
    return MstTransportRelationUpdateBaseFromJSONTyped(json, false);
}

export function MstTransportRelationUpdateBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstTransportRelationUpdateBase {
    if (json == null) {
        return json;
    }
    return {
        
        'deleteFlg': json['delete_flg'] == null ? undefined : json['delete_flg'],
        'insertDatetime': json['insert_datetime'] == null ? undefined : (new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'] == null ? undefined : json['insert_user'],
        'updateDatetime': json['update_datetime'] == null ? undefined : (new Date(json['update_datetime'])),
        'updateUser': json['update_user'] == null ? undefined : json['update_user'],
        'deleteDatetime': json['delete_datetime'] == null ? undefined : (new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'] == null ? undefined : json['delete_user'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'orgCenterId': json['org_center_id'] == null ? undefined : json['org_center_id'],
        'orgCustomerId': json['org_customer_id'] == null ? undefined : json['org_customer_id'],
        'orgCustomerCenterId': json['org_customer_center_id'] == null ? undefined : json['org_customer_center_id'],
        'leadtime': json['leadtime'] == null ? undefined : json['leadtime'],
        'maxTrafficVolume': json['max_traffic_volume'] == null ? undefined : json['max_traffic_volume'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function MstTransportRelationUpdateBaseToJSON(json: any): MstTransportRelationUpdateBase {
    return MstTransportRelationUpdateBaseToJSONTyped(json, false);
}

export function MstTransportRelationUpdateBaseToJSONTyped(value?: MstTransportRelationUpdateBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'company_id': value['companyId'],
        'org_center_id': value['orgCenterId'],
        'org_customer_id': value['orgCustomerId'],
        'org_customer_center_id': value['orgCustomerCenterId'],
        'leadtime': value['leadtime'],
        'max_traffic_volume': value['maxTrafficVolume'],
        'remarks': value['remarks'],
    };
}

